import { memo, useState } from 'react'
import Field from './Field'
import InputFieldSkeleton from './InputFieldSkeleton'
import { CRRender } from '../../crRender'
import { CheckArabicText, CheckEnglishText } from '@/utils'
import "../inputsGlobals.css"


const InputField = ({ isLoading, name, formHandler, isRequired = true, isDisabled = false, type = "text", className = "col-md-6", defaultValue, min, max, step, lang = "Ar" }) => {
    const { formValues, handleFormValues, errors } = formHandler
    const [inputClassNAme, setClassName] = useState("")

    const handleValue = (val, options = {}) => {
        handleFormValues(name, { ...val, min, max, type }, options)
        if (lang == "Ar" && val?.value != "") {
            if (CheckArabicText(val?.value)) {
                setClassName("")
            } else {
                setClassName("value-error")
            }
        }
        if (lang == "En" && val?.value != "") {
            if (CheckEnglishText(val?.value)) {
                setClassName("")
            } else {
                setClassName("value-error")
            }
        }
    }



    return (
        <>
            <InputFieldSkeleton isRender={isLoading} className={className} />
            <CRRender isRender={!isLoading}>
                <Field
                    className={`${className} ${inputClassNAme}`}
                    label={name}
                    type={type}
                    defaultValue={defaultValue}
                    isRequired={isRequired}
                    lang={lang}
                    disabled={isDisabled}
                    value={formValues[name]}
                    setValue={(val, options) => handleValue(val, options)}
                    min={min}
                    max={max}
                    step={step}
                    errorMessage={errors[name]?.errorMessage}
                    />
            </CRRender>
        </>
    )

}

export default memo(InputField)
